<template>
  <button class="btn btn-secondary btn-size-medium" @click="confirmRestartExperience">
    Restart this Experience
  </button>
</template>

<script>
import store from '@/store/store';

export default {
  data() {
    return {
      disableSubmit: false,
      experienceID: this.$route.params.id,
    };
  },
  computed: {
    activeExperienceID() {
      return store.getters['authStudent/activeExperienceID'];
    },
  },
  methods: {
    confirmRestartExperience() {
      const vm = this;
      let title = `Restart Work Experience?`;
      let color = 'primary';
      let text = 'Are you sure you want to restart this Work Experience?';
      if (this.activeExperienceID) {
        title = 'You already have an active Work Experience';
        color = 'danger';
        text =
          'Are you sure you want to restart this Work Experience? This will cancel the existing Work Experience and restart the old one.';
      }
      this.$vs.dialog({
        type: 'confirm',
        color: color,
        title: title,
        text: text,
        accept: async function () {
          await vm.restartExperience();
        },
      });
    },
    async restartExperience() {
      await store.dispatch('authStudent/restartExperience', this.experienceID);
    },
  },
};
</script>
